export enum ListingFlow {
    BUSINESS_CATEGORIES = 'business_categories',
    BUSINESS_SEARCH = 'business_search',
}
